import { Icon } from '../../ui/bootstrap/bootstrap'

import styles from './RecipeTemperature.sass'

// When used as a draft-js decorator, children carry the editable
// text and have to be rendered as-is.
export const RecipeTemperature = ({ temp, unit, children }) =>
  <span className={styles.temp}>
    <span contentEditable={false}>
      <Icon icon="fire" />
      {' '}
    </span>
    {children || `${temp}º ${unit}`}
  </span>
